import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  sectionCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  sectionTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  sectionDescription: {
    color: colorsConstants.primaryText,
    opacity: 0.8,
    mb: 2,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  actionRow: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: 1,
    alignItems: "center",
  },
  emptyStateText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  requestsList: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  requestCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    boxShadow: "none",
  },
  requestTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 1,
  },
  requestMetaText: {
    color: colorsConstants.primaryText,
    opacity: 0.85,
    mb: 0.5,
  },
  requestActionsContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mt: 2,
  },
  preferenceText: {
    color: colorsConstants.primaryText,
    opacity: 0.85,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
